// Envío de la tienda en línea (negocios.tienda_envio, sql/113).
//   fijo      → mismo precio a todo el país; gratis desde un monto (opcional)
//   coordinar → varía; la tienda lo confirma por WhatsApp
// Es el mismo cálculo que hace la BD (costo_envio): aquí solo se MUESTRA.

export const ENVIO_DEFECTO = { modo: 'coordinar', costo: 0, gratisDesde: 0, recoger: true, apartarHoras: 24 };

// Horas que se apartan las piezas de un pedido (sql/123). 0 = no apartar.
export const HORAS_APARTADO = [0, 12, 24, 48, 72];

const monto = (v) => {
  const n = Number(v);
  return Number.isFinite(n) && n > 0 ? Math.min(Math.round(n * 100) / 100, 100000) : 0;
};

export function normalizarEnvio(e) {
  const o = e && typeof e === 'object' && !Array.isArray(e) ? e : {};
  return {
    modo: o.modo === 'fijo' ? 'fijo' : 'coordinar',
    costo: monto(o.costo),
    gratisDesde: monto(o.gratisDesde),
    recoger: o.recoger !== false,
    apartarHoras: HORAS_APARTADO.includes(Number(o.apartarHoras)) ? Number(o.apartarHoras) : 24,
  };
}

// null = se coordina por WhatsApp · 0 = gratis / recoge en tienda.
export function costoEnvio(config, entrega, subtotal) {
  const c = normalizarEnvio(config);
  if (entrega === 'tienda') return 0;
  if (entrega !== 'domicilio' || c.modo !== 'fijo') return null;
  if (c.gratisDesde > 0 && subtotal >= c.gratisDesde) return 0;
  return c.costo;
}

// Frase corta para la bolsa: "Envío a todo el país: L 90.00 · gratis desde L 1,000.00".
export function resumenEnvio(config, dinero) {
  const c = normalizarEnvio(config);
  if (c.modo !== 'fijo') return 'El envío se coordina contigo por WhatsApp.';
  const base = c.costo > 0 ? `Envío a todo el país: ${dinero(c.costo)}` : 'Envío gratis a todo el país';
  return c.gratisDesde > 0 && c.costo > 0 ? `${base} · gratis desde ${dinero(c.gratisDesde)}` : base;
}

export const ENTREGAS = { domicilio: '🚚 Envío a domicilio', tienda: '🏬 Recoger en la tienda' };
